import React, { useEffect } from 'react';
import Headers from '../components/Headers';
import Footer from '../components/Footer';
import { useDispatch, useSelector } from 'react-redux';
import { get_sellers } from '../store/reducers/homeReducer';
import SellerCard from '../components/seller-card';
import SEO from '../components/SEO';

const Sellers = () => {
    const dispatch = useDispatch();
    const { sellers } = useSelector(state => state.home);

    useEffect(() => {
        dispatch(get_sellers());
    }, [dispatch]);

    return (
        <div className='w-full'>
            <SEO title="Sellers | Apna Plaza" description="Meet our trusted sellers and explore their unique shops on Apna Plaza." />
            <Headers />
            
            {/* Page Header */}
            <div className='bg-card py-11 border-b border-primaryLighter'>
                <div className='w-full'>
                    <div className='flex flex-col justify-center items-start container mx-auto'>
                        <div className='flex justify-center items-center gap-3 mb-1 text-sm font-medium text-secondary'>
                            <span className="hover:text-primary cursor-pointer transition-colors">Home</span>
                            <span className="text-primary">/</span>
                            <span className="text-primary">Sellers</span>
                        </div>
                        <h2 className='text-4xl font-medium text-priamry tracking-tight'>OUR SELLERS</h2>
                        <p className='text-textSecondary text-base'>Trusted Sellers Offering Qualtiy Product</p>
                    </div>
                </div>
            </div>

            <section className='py-20 lg:py-10 sm:pb-28'>
                <div className='container mx-auto'>
                    <div className='grid md:grid-cols-1 xl:grid-cols-2 grid-cols-3 gap-6 '>
                        {sellers && sellers.length > 0 ? (
                            sellers.map((seller, i) => (
                                <SellerCard key={i} seller={seller} />
                            ))
                        ) : (
                            <div className='col-span-full py-32 text-center bg-card rounded-3xl border border-dashed border-primaryLighter'>
                                <div className="text-slate-300 text-6xl mb-4">🏪</div>
                                <p className='text-xl text-slate-500 font-medium'>No sellers found at the moment.</p>
                                <p className='text-slate-400 text-sm mt-1'>Check back later for new arrivals.</p>
                            </div>
                        )}
                    </div>
                </div>
            </section>
            
            <Footer />
        </div>
    );
};

export default Sellers;
